module.exports = __webpack_public_path__ + "media/56.0de4161c.wav";